import { render } from "./DriveInfo.vue?vue&type=template&id=190c4e65&scoped=true&ts=true"
import script from "./DriveInfo.vue?vue&type=script&lang=ts"
export * from "./DriveInfo.vue?vue&type=script&lang=ts"

import "./DriveInfo.vue?vue&type=style&index=0&id=190c4e65&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190c4e65"]])

export default __exports__